import storage from "./storage";
import authService from "@/services/auth.service";

let apiToken = {
  tokenExpire: function (obj) {
    storage.saveAuthenticated(false);
    storage.saveToken("", "", "");
    storage.removeItemsSessionStorage();

    if (authService.isUsingOAuth2()) {
      window.location.href = `/oauth2/start?rd=${encodeURIComponent(
        window.location.origin + window.location.pathname
      )}`;
    } else {
      obj.$router.replace({ name: "login" });
    }
  },
};
export default apiToken;
